import { axios } from "services";

export const resendVerification = async ({ email }) => {
  const response = await axios.post("/resendVerification", { email });
  return response.data;
};

